import ScrollMagic from 'ScrollMagic'
import 'ScrollMagic/scrollmagic/minified/plugins/debug.addIndicators.min.js'

import SMEvent from './SMEvent'

export default {
  install (Vue, options = {}) {
    const {
      global = true
    } = options
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      Vue.mixin({
        computed: {
          $smController () {
            return new ScrollMagic.Controller()
          },
          $sm () {
            return ScrollMagic
          }
        }
      })
    }
    if (global) {
      Vue.component('sm-event', SMEvent)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-scrollmagic/index.js